import { IconWrapper } from '../runtime';
export default IconWrapper('baby', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M24 43.5999C32.432 43.5999 39.5606 36.919 41.8935 29.2496C42.4179 27.5253 46 27.5253 46 23.7999C46 20.0744 42.3839 19.86 41.7987 18.0479C39.3724 10.5345 32.3209 3.99986 24 3.99986C15.6745 3.99986 8.61973 10.5406 6.19725 18.0605C5.61467 19.8689 2 20.009 2 23.7999C2 27.5907 5.59225 27.5907 6.1349 29.3419C8.4967 36.9638 15.6018 43.5999 24 43.5999Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("path", {
    "attrs": {
      "d": "M41.7987 18.0479C39.3724 10.5345 32.3209 3.99986 24 3.99986",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap
    }
  }), h("path", {
    "attrs": {
      "d": "M19.1002 21.5997C19.1002 22.426 18.876 23.1515 18.5398 23.6558C18.2013 24.1636 17.7885 24.3997 17.4002 24.3997C17.0119 24.3997 16.5991 24.1636 16.2606 23.6558C15.9244 23.1515 15.7002 22.426 15.7002 21.5997C15.7002 20.7733 15.9244 20.0479 16.2606 19.5436C16.5991 19.0358 17.0119 18.7997 17.4002 18.7997C17.7885 18.7997 18.2013 19.0358 18.5398 19.5436C18.876 20.0479 19.1002 20.7733 19.1002 21.5997Z",
      "fill": props.colors[2],
      "stroke": props.colors[2]
    }
  }), h("path", {
    "attrs": {
      "d": "M32.2999 21.5997C32.2999 22.426 32.0757 23.1515 31.7395 23.6558C31.401 24.1636 30.9882 24.3997 30.5999 24.3997C30.2116 24.3997 29.7988 24.1636 29.4603 23.6558C29.1241 23.1515 28.8999 22.426 28.8999 21.5997C28.8999 20.7733 29.1241 20.0479 29.4603 19.5436C29.7988 19.0358 30.2116 18.7997 30.5999 18.7997C30.9882 18.7997 31.401 19.0358 31.7395 19.5436C32.0757 20.0479 32.2999 20.7733 32.2999 21.5997Z",
      "fill": props.colors[2],
      "stroke": props.colors[2]
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M18.498 31.7503C20.4289 33.05 22.266 33.6998 24.0094 33.6998C25.7509 33.6998 27.4776 33.0514 29.1894 31.7545",
      "fill": props.colors[2]
    }
  }), h("path", {
    "attrs": {
      "d": "M18.498 31.7503C20.4289 33.05 22.266 33.6998 24.0094 33.6998C25.7509 33.6998 27.4776 33.0514 29.1894 31.7545",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap
    }
  }), h("path", {
    "attrs": {
      "d": "M31.7283 6.20005C31.9964 8.13353 31.4067 9.54637 29.9593 10.4386C28.5119 11.3307 26.1602 11.7488 22.9043 11.6928",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap
    }
  })]);
});